import { PageHeader } from "components";
import { NextPage } from "next";
import { ReactNode } from "react";

const Content: React.FC<{
  title: string;
  subtitle: string;
  policy: ReactNode;
}> = ({ policy, title, subtitle }) => {
  return (
    <div className="container">
      <div className="text-center">
        <h2 className="heading-2">{title}</h2>
        <h3 className="lg:text-4xl text-xl lg:my-12 my-8">{subtitle}</h3>
      </div>
      <div className="formHeadings jetsonLinksStyle space-y-6 text-justify">
        {policy}
      </div>
    </div>
  );
};

const policyContent: ReactNode = (
  <>
    <p>
      At Jetson Inc. we take privacy issues very seriously. This Privacy Policy
      is to inform you about our regulations in this matter and about our legal
      obligations. In addition to these requirements, we want you to know that
      we are always open to your questions and doubts. If you have any
      suggestions on how we can better take care of your and our safety - do not
      hesitate and contact us.
    </p>
    <p>
      All these provisions and our privacy principles are based on the
      provisions of the law resulting from the California Consumer Privacy Act
      of 2018 and Regulation 2016/679 of the European Parliament and the Council
      of 27 April 2016 on the protection of natural persons with regard to the
      processing of personal data and on the free movement of such data, and
      repealing Directive 95/46 / EC (the GDPR). Due to our special attention to
      the processing of personal data, our practices also comply with the UK
      Data Protection Act 2018, Canada&apos;s Personal Information Protection
      and Electronic Documents Act (PIPEDA), and Japan&apos;s Act on the
      Protection of Personal Information (APPI).
    </p>

    <p>
      <strong>1. Who is your data controller ?</strong>
    </p>
    <p>
      The controller of your personal data is Jetson Inc. registered in State of
      California You can contact us via e-mail: privacy@jetson.com
    </p>

    <p>
      <strong>2. What data do we process?</strong>
    </p>
    <p>
      For the purposes described below, we collect and process the following
      personal data:
    </p>
    <ul className="list-disc pl-6 space-y-2">
      <li>
        Identification data. Data such as name, surname, age, permission to use
        our vehicle (if required), ID number and correspondence address that are
        necessary to place an order, conduct the sales process, conduct
        after-sales service, as well as create a user account in our store.
      </li>
      <li>
        Contact details. An e-mail address is necessary to place an order and
        register a customer account in our store. The e-mail address may also be
        used to provide certain functionalities of our store. In terms of
        contact with the user, we can also process the telephone number of our
        clients.
      </li>
      <li>
        Sales/pre-order data. In order to fulfill our obligations towards our
        customers and in connection with legal obligations, we may process sales
        data such as order number, payment data, delivery data, etc.
      </li>
      <li>
        Information on browsing the store&apos;s website. Data such as access
        time, number of accesses, IP address and information about actions on
        website (such as errors, freezes, reboots and upgrades to new versions)
        and other diagnostic, error and usage information e.g. time of using the
        services, the search terms entered by the User on the website and any
        information stored in cookies placed on the User&apos;s device.
      </li>
      <li>
        Cookies. We use cookies on the website of our store. These are IT data,
        most often text files, that are stored on the end device. They usually
        contain the name of the website they come from, storage time and number.
      </li>
    </ul>
    <p>
      Our site where this Privacy Policy is found is meant for adults. We do not
      knowingly collect personally identifiable information from children under
      the age of 18 without permission from a parent or guardian. If you are a
      parent or legal guardian and think your child under 18 has given us
      information, you can contact us at privacy@jetson.com
    </p>

    <p>
      <strong>
        3. Your personal data will be processed for the following purposes:
      </strong>
    </p>
    <ul className="list-disc pl-6 space-y-2">
      <li>
        Carrying out the sales/pre-order process and after-sale services - we
        may use your identification data and contact details;
      </li>
      <li>
        Issuing an invoice and meeting other requirements arising from the
        provisions of tax law - we may use your identification data, contact
        details and sales details;
      </li>
      <li>Direct marketing - we may use your contact details;</li>
      <li>
        Establishment, exercise or defense of legal claims - we may use your
        identification data, contact details, sales details;
      </li>
      <li>
        Analytical purposes, among others analyses of the data automatically
        collected using the Website, including cookies - we may use information
        on browsing the website, cookies
      </li>
      <li>
        Uploading comments to the website - we may use your identification data
        and contact details -
      </li>
    </ul>
    <p>
      You can withdraw your consent any time provided that such withdrawal does
      not affect the lawfulness of processing based on consent before its
      withdrawal.
    </p>

    <p>
      <strong>4. Are you required to provide your personal data ?</strong>
    </p>
    <p>Provision of personal data is voluntary, however:</p>
    <ul className="list-disc pl-6 space-y-2">
      <li>
        Provision of such data as name and e-mail address is necessary for
        evaluation of the service and conclusion of the agreement (provision of
        the service will be impossible without that data);
      </li>
      <li>
        Provision of such data as name, e-mail address, order number is
        necessary for resolution of the complaint and in the case of money
        reimbursement - also provision of address of residence and bank account
        number (without that data, the complaint cannot be resolved and
        reimbursement cannot be made);
      </li>
      <li>
        Provision of such data as name and surname, company name, registered
        address, tax number is necessary for issuing of an invoice for the
        services and results from the provisions of law (invoices cannot be
        issued without that data);
      </li>
      <li>
        In case of shipping the order to particular countries - it is necessary
        to provide the ID number so as to ship the order (without providing the
        ID number it will be impossible to ship the order to particular
        countries).
      </li>
    </ul>

    <p>
      <strong>5. Data recipients</strong>
    </p>
    <p>
      Your personal data can be shared with our couriers, lawyers, payment
      service providers, hosting company, accounting company, insurance company,
      the company managing the ERP system, the company involved in customer
      service management, any other kind of business advisors as well as other
      companies and their representatives that belong to Jetson capital group.
    </p>
    <p>
      Your personal data may be transferred by theJetson Inc. to our technology
      vendors such as Google LLC, Facebook Inc, Twitter Inc.
    </p>

    <p>
      <strong>6. Personal data storage duration</strong>
    </p>
    <p>
      Your personal data will be stored as long as we are required to do so by
      law. Most often it is a period of 3 years, but in special cases (e.g.
      liability) it may be longer.
    </p>
    <p>
      If there are no legal provisions regulating the period of data storage, we
      will process them until you object to the processing of personal data.
    </p>

    <p>
      <strong>
        7. Information about your rights connected with personal data processing
      </strong>
    </p>
    <p>You are entitled to:</p>
    <ul className="list-disc pl-6 space-y-2">
      <li>Access your personal data;</li>
      <li>Request correction of the data;</li>
      <li>Deletion of data and limitation of data processing;</li>
      <li>Limit use and disclosure of sensitive personal information;</li>
      <li>
        Transfer the data to the format selected by you (appropriate for the
        type of data) and to the electronic address provided by you;
      </li>
    </ul>
    <p>
      California residents also have the right to opt-out of the
      &quot;sale&quot; of their data. The word &quot;sale&quot; is used in
      quotation marks because the California statute considers some transfers of
      Personal Information to third parties in exchange for value as
      &quot;sales,&quot; even if no money changes hands, such as when online
      identifiers, device IDs, and other information is shared with third party
      businesses to further their own commercial purposes.
    </p>
    <p>
      You can request execution of your rights by sending an email to
      privacy@jetson.com. Your request should contain the data allowing us to
      identify you.
    </p>
    <p>
      Please remember that the use of these rights may, in some cases, hinder
      our cooperation. Our employees from the privacy department provide
      assistance and explain the consequences of the modification in the field
      of data processing.
    </p>

    <p>
      <strong>
        8. The right to lodge a complaint with a supervisory authority
      </strong>
    </p>
    <p>
      If you decide that your personal data are processed against the law you
      are entitled to lodge a complaint with a supervisory authority engaged in
      personal data protection in your country of residence.
    </p>

    <p>
      <strong>9. Security measures</strong>
    </p>
    <p>
      We make every effort to secure your personal data and protect it against
      the actions of third parties. We use all the necessary security measures
      for servers, connections and website to protect data, in particular SSL
      encryption. All connections related to the execution of payments by our
      clients will take place via a secure encrypted connection.
    </p>
    <p>
      We would like to inform you that the actions we take may turn out to be
      insufficient if our clients do not follow the safety rules themselves. In
      particular, each user should keep the login and password to his account on
      the website confidential and not disclose them to third parties.
    </p>
    <p>
      For more information on our security measures or any data protection
      related questions please contact us on privacy@jetson.com
    </p>
    <p>
      We may modify or update this Privacy Policy from time to time, so please
      review it periodically. We may provide you with notice of material changes
      to the Privacy Policy as appropriate under the circumstances. Unless
      otherwise indicated, any changes to this Privacy Policy will apply
      immediately upon posting on our website.
    </p>
  </>
);

const PrivacyPolicy: NextPage = () => {
  return (
    <div className="bg-white py-section">
      <PageHeader title="Privacy Policy" />
      <Content
        policy={policyContent}
        subtitle="Personal Data Protection"
        title="Privacy Policy"
      />
    </div>
  );
};
export default PrivacyPolicy;
